import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Popover, QRCode, Table, Tooltip } from "antd";
// import axios from "axios";
// import {
//   CustomerOrderInfo,
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../context";
import {
  AuditOutlined,
  DeleteOutlined,
  QrcodeOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
// import MerchantOrdersDetails from "./MerchantOrdersDetails";
// import MerchantLayout from "../../layout/MerchantLayout";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import {
//   CustomerOrderInfo,
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
// import {
//   CustomerOrderInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../context";
import axios from "axios";
import MerchantCheckoutPayLater from "./MerchantCheckoutPayLater";
import _ from "lodash";
import { UserInfo, SubscriptionInfo } from "./../../../context";
import LOGO from "./../../../assets/tinyimg/logo.webp";

const MerchantOrderPayLater = () => {
  const [search, setSearch] = useState("");
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  //   const { rerunNotif } = useContext(NotificationInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();
  const [merchantPayLaterList, setMerchantPayLaterList] = useState({
    data: [],
    ready: false,
  });

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      // title: dineTypeList && allowDineSetup ? "Location" : "Table Number",
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    // {
    //   title: "Cost",
    //   dataIndex: "cost",
    //   align: "right",
    //   render: (text, record) => (
    //     <p>
    //       {text.toLocaleString(undefined, {
    //         minimumFractionDigits: 2,
    //         maximumFractionDigits: 2,
    //       })}
    //     </p>
    //   ),
    // },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 100,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 100 }}>
          <Tooltip title="Order QR" placement="bottom">
            <Popover
              overlayInnerStyle={{
                padding: 0,
              }}
              content={
                <QRCode
                  value={`${import.meta.env.VITE_API_SITE_URL}${
                    userData.data.id
                  }/${userData.data.merchant_uid}/${text.transaction_id}`}
                  bordered={false}
                  style={{
                    marginBottom: 16,
                  }}
                  icon={LOGO}
                  errorLevel="Q"
                />
              }
            >
              <Button
                type="dashed"
                shape="circle"
                //   onClick={() => {
                //     setSelectedData(text);
                //     // setOpenExtendDrawer(true);
                //   }}
                icon={<QrcodeOutlined />}
                style={{ marginRight: 5 }}
                size="small"
              />
            </Popover>
          </Tooltip>

          <Tooltip title="Checkout">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<ScheduleOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip>

          {/* <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
              size="small"
              disabled
            />
          </Tooltip> */}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getAllPayLater = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      status: 1,
      orderby: "asc",
      order_category: "products",
    };
    axios
      .get("user/merchant/pay-later-list", {
        params,
      })
      .then((response) => {
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,
            customer_name: value[0].customer_name,
            created_at: value[0].created_at,
            table_no: value[0].table_no,
            service_category: value[0].service_category,
            // cost: getTotalCost(value),
          }))
          .value();
        // console.log("RES: ", res);

        const res2 = _.orderBy(res, ["created_at"], ["desc"]);
        // console.log("RES2: ", res2);

        setMerchantPayLaterList({ data: res2, ready: true });

        // console.log("RES2", res2);
        // setMerchantOrderSaveList({ data: res2, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductList();
    getAllPayLater();
  }, [getProductList, getAllPayLater]);

  const searchable = merchantPayLaterList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  // const handleOk = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setDeleteDialog(false);
  //     setConfirmLoading(false);
  //     handleDeleteCustomerService();
  //   }, 2000);
  // };

  // const handleDeleteCustomerService = () => {
  //   const formdata = new FormData();
  //   formdata.append("user_id", userData.data.id);
  //   formdata.append(
  //     "transaction_id",
  //     selectedData !== null ? selectedData.transaction_id : ""
  //   );
  //   axios
  //     .post("user/merchant/delete-avail-service", formdata)
  //     .then((response) => {
  //       const data = response.data;
  //       if (data === "success") {
  //         rerunNotif("success", "Delete transaction successfully.");
  //         setTimeout(() => {
  //           // setLoadings(false);
  //           rerun();
  //         }, 1000);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error: ", error);
  //       // setLoadings(false);
  //     });
  // };

  return (
    <MerchantLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>

      {openDrawer && (
        <MerchantCheckoutPayLater
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getAllPayLater={() => getAllPayLater()}
          selectedData={selectedData}
          productList={productList}
        />
      )}

      {/* <Modal
        title="Delete this transaction?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      /> */}
    </MerchantLayout>
  );
};

export default MerchantOrderPayLater;
